//material ui
import Button from '@material-ui/core/Button';

import React from 'react';

const basePath = window.location.href.split('#')[0];

let tableView = str => {
  let elements = document.getElementsByClassName('meta-data');

  for (let i = 0; i < elements.length; i++) {
    elements[i].classList.remove('hidden');
  }

  let subCatList = document.getElementsByClassName('subcategory--list');

  for (let j = 0; j < subCatList.length; j++) {
    subCatList[j].classList.add('flex-column');
  }

  document.getElementById('grid-view').classList.remove('selected');
  document.getElementById('table-view').classList.add('selected');

  // updateSubcatView.updateSubcatView('table');
};

let gridView = str => {
  let elements = document.getElementsByClassName('meta-data');

  for (let i = 0; i < elements.length; i++) {
    elements[i].classList.add('hidden');
  }

  let subCatList = document.getElementsByClassName('subcategory--list');

  for (let j = 0; j < subCatList.length; j++) {
    subCatList[j].classList.remove('flex-column');
  }

  document.getElementById('table-view').classList.remove('selected');
  document.getElementById('grid-view').classList.add('selected');

  // updateSubcatView.updateSubcatView('grid');
};

export class ViewToggle extends React.Component {
  render() {
    return (
      <div className='toggle-buttons-container'>
        <Button
          variant='contained'
          id='grid-view'
          className='grid-icon selected'
          label=''
          secondary='true'
          onClick={gridView.bind(this, 'grid')}
        />
        <Button
          variant='contained'
          id='table-view'
          className='table-icon'
          label=''
          secondary='true'
          onClick={tableView.bind(this, 'table')}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/toolbar/viewToggle.js